import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export const journalListMixin = {
  data() {
    return {
      totalItems: 0,
      items: [],
      selectedPage: 0,
      pagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      selectedJournalColumns: ['jrnlNo', 'date', 'curr', 'amount', 'reason', 'statusDesc'],
      journalColumns: [
        { text: 'Jrnl No', value: 'jrnlNo' },
        { text: 'Date', value: 'date' },
        { text: 'Curr', value: 'curr' },
        { text: 'Amount', value: 'amount' },
        { text: 'Reason', value: 'reason' },
        { text: 'Amount ', value: 'amount' },
        { text: 'Status', value: 'statusDesc' }
      ],
      totalGlDetItems: 0,
      glDetItems: [],
      selectedGlDetPage: 0,
      paginationGlDet: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      selectedGLDetColumns: ['branch', 'glAcctNo', 'fund', 'suffix', 'desc', 'curr', 'adj', 'local'],
      glDetColumns: [
        { text: 'Branch', value: 'branch' },
        { text: 'GL Account No.', value: 'glAcctNo' },
        { text: 'Fund', value: 'fund' },
        { text: 'Suffix', value: 'suffix' },
        { text: 'Description', value: 'desc' },
        { text: 'Currency', value: 'curr' },
        { text: 'Adjustment', value: 'adj' },
        { text: 'Local', value: 'local' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listJournalHeaders() {
      let result = []
      for (const selectedJournalColumn of this.selectedJournalColumns) {
        let findCol = this.journalColumns.find(a => selectedJournalColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listGlDetHeaders() {
      let result = []
      for (const selectedGlDetColumn of this.selectedGLDetColumns) {
        let findCol = this.glDetColumns.find(a => selectedGlDetColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    'pagination': function (value) {
      this.performSearch(false)
    },
    'paginationGlDet': function (value) {
      this.performSearch(false)
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
